import type { Workflow } from '@lighthouse/shared'
import { atom } from 'jotai'

import http from '@/http'
import * as srv from '@/services'

import { workflowListAtom } from './state'

export const fetchWorkflowListAtom = atom(null, async (_, set) => {
    // listWorkflow 靠请求头 B-App-Id 区分应用。切换应用时上一个请求可能后返回，不能拿它覆盖当前列表。
    const requestedAppId = http.defaults.headers.common['B-App-Id']
    const data = await srv.listFlowNodes()
    if (http.defaults.headers.common['B-App-Id'] !== requestedAppId) {
        return
    }
    set(workflowListAtom, Array.isArray(data) ? data : [])
})

export const fetchWorkflowAtom = atom(null, async (_, set, id: string) => {
    const data = await srv.fetchFlow(id)
    set(workflowListAtom, draft => {
        const index = draft.findIndex(item => item.id === id)
        if (index >= 0) {
            draft[index] = data
        } else {
            draft.push(data)
        }
    })
    return data
})

export const addWorkflowAtom = atom(null, (_, set, data: Workflow) => {
    set(workflowListAtom, draft => {
        draft.push(data)
    })
    return data
})

export const deleteWorkflowAtom = atom(null, (_, set, id: string) => {
    set(workflowListAtom, draft => {
        const index = draft.findIndex(item => item.id === id)
        if (index >= 0) {
            draft.splice(index, 1)
        }
    })
})
